/**
 * Reports an unrenderable illustration request once, from an effect.
 *
 * Shared by both renderers so the platform difference is exactly which reason
 * they pass, not a second copy of the reporting rule. The effect placement is
 * load-bearing rather than stylistic: reporting mutates module state and writes
 * to the console, and React Compiler skips a component whose body does either.
 */

import { useEffect } from 'react';

import type { IllustrationWarningReason } from './CharacterIllustration';
import { warnIllustrationOnce } from './CharacterIllustration';

export function useIllustrationWarning(
  name: string,
  reason: IllustrationWarningReason | null,
): void {
  useEffect(() => {
    if (reason !== null) {
      warnIllustrationOnce(name, reason);
    }
  }, [name, reason]);
}
